import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/add-funds',
    name: 'AddFundsPage',
    component: () => import('@/modules/addFunds/views/AddFundsPage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/add-funds/complete/:invoiceId',
    name: 'AddFundsCompletePage',
    component: () => import('@/modules/addFunds/views/AddFundsCompletePage.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/stripe/:invoiceId',
    name: 'SelectCardForm',
    component: () => import('@/modules/addFunds/components/SelectCardForm.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
  router.addRoute({
    path: '/paypal/:invoiceId',
    name: 'PaypalForm',
    component: () => import('@/modules/addFunds/components/PaypalForm.vue'),
    meta: {
      layout: 'DefaultLayout',
    },
  })
}
